import React, { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { api } from '../api';
import { SkeletonRows, ErrorMessage, usePageMeta } from '../components/ui';

export const GAMES = { brawl: 'Brawl Stars', clash: 'Clash Royale' };
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export const postDay = (iso) => {
  const [y, m, d] = iso.slice(0, 10).split('-').map(Number);
  return `${MONTHS[m - 1]} ${d}, ${y}`;
};

/* Posts the publisher writes from the stats (backend app/publisher.py):
   brawlers climbing or falling, best picks per mode, rising Clash decks. */
function News() {
  const { pathname } = useLocation();
  const [game, setGame] = useState('');
  const [posts, setPosts] = useState(null);
  const [error, setError] = useState(null);
  usePageMeta({
    title: 'Brawl Stars & Clash Royale Meta News',
    description: 'Daily Brawl Stars and Clash Royale meta news from tracked battles: brawlers climbing and falling, best picks per mode, and rising decks.',
  });

  const load = useCallback(async () => {
    setPosts(null);
    setError(null);
    try {
      setPosts(await api.getPosts(game || undefined));
    } catch (err) {
      setError(err.message);
    }
  }, [game]);

  useEffect(() => { load(); }, [load, pathname]);

  return (
    <div className="page">
      <div className="wrap">
        <div className="phead">
          <div>
            <div className="eyebrow">News · from tracked battles</div>
            <h1>Meta news</h1>
            <div className="sub">
              Brawlers on the rise, new best picks for each mode, and the Clash Royale decks taking off.
              Written from the stats whenever something really moves.
            </div>
          </div>
        </div>

        <div className="filters">
          <div className="seg">
            <button className={game === '' ? 'on' : ''} onClick={() => setGame('')}>All</button>
            <button className={game === 'brawl' ? 'on' : ''} onClick={() => setGame('brawl')}>Brawl Stars</button>
            <button className={game === 'clash' ? 'on' : ''} onClick={() => setGame('clash')}>Clash Royale</button>
          </div>
        </div>

        {error ? (
          <ErrorMessage message={error} onRetry={load} />
        ) : !posts ? (
          <SkeletonRows rows={6} />
        ) : posts.length === 0 ? (
          <p className="empty-state">No posts yet. The first one goes up when the meta next moves.</p>
        ) : (
          <div className="news-list">
            {posts.map((p) => (
              <Link key={p.slug} to={`/news/${p.slug}`} className="news-item">
                <div className="news-meta">
                  <span className={`pill-chip ${p.game === 'clash' ? '' : 'lime'}`}>{GAMES[p.game]}</span>
                  <span>{postDay(p.published_at)}</span>
                </div>
                <div className="news-title">{p.title}</div>
                <div className="news-desc">{p.description}</div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default News;
